import { getApp, getApps, initializeApp } from "firebase/app";
import {
  CustomProvider,
  getToken,
  initializeAppCheck,
  ReCaptchaV3Provider,
} from "firebase/app-check";

const CENTRAL_APP_NAME = "andus-central-access-app-check";

let centralAppCheck = null;

function centralFirebaseApp() {
  const existing = getApps().find((app) => app.name === CENTRAL_APP_NAME);
  return existing || initializeApp(getApp().options, CENTRAL_APP_NAME);
}

function initializeCentralAppCheck() {
  if (centralAppCheck || typeof window === "undefined") return centralAppCheck;

  const isDevelopment = process.env.NODE_ENV !== "production";
  const siteKey = String(
    process.env.REACT_APP_FIREBASE_APP_CHECK_SITE_KEY || "",
  ).trim();
  const debugToken = isDevelopment ? String(
    process.env.REACT_APP_FIREBASE_APP_CHECK_DEBUG_TOKEN || "",
  ).trim() : "";
  const debugEnabled = isDevelopment && (!siteKey || Boolean(debugToken));

  if (!siteKey && !debugEnabled) return null;

  if (debugEnabled) {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN =
      debugToken && debugToken !== "true" ? debugToken : true;
  }

  // Firebase exchanges the registered debug token before invoking the
  // provider. Supplying a CustomProvider lets localhost use that supported
  // debug flow without requiring a production reCAPTCHA site key. Its token
  // method deliberately fails closed if debug mode is ever bypassed.
  const provider = siteKey
    ? new ReCaptchaV3Provider(siteKey)
    : new CustomProvider({
        getToken: async () => {
          throw new Error(
            "Central access App Check debug mode is not active.",
          );
        },
      });

  centralAppCheck = initializeAppCheck(centralFirebaseApp(), {
    provider,
    isTokenAutoRefreshEnabled: true,
  });
  return centralAppCheck;
}

/**
 * App Check for the central-access API lives on a secondary Firebase app.
 * This keeps the shared default app used by every legacy route byte-for-byte
 * compatible: no App Check provider or token refresh is installed there.
 */
export async function getCentralAccessAppCheckToken() {
  const appCheck = initializeCentralAppCheck();
  if (!appCheck) return "";
  const result = await getToken(appCheck, false);
  return String(result?.token || "");
}

export const centralAccessAppCheckTestables = Object.freeze({
  centralFirebaseApp,
  initializeCentralAppCheck,
});
